import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { operacion } from '../../../shared/object/operaciones.model';
import { validate } from 'graphql';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-operaciones',
  templateUrl: './operaciones.component.html',
  styleUrls: ['./operaciones.component.scss'],
  providers: [SecurityService, ValidadoresService]
})

export class OperacionesComponent implements OnInit {
  private client: GraphQLClient = null;
  operacionList: operacion[];
  selectedOperacion: operacion;
  operacion: operacion;
  public nombre:string;
  formulario: FormGroup;
  @ViewChild('agregarOperaciones', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarOperaciones', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 24;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  
  constructor(client: GraphQLClient, 
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
    ) {
    this.client = client;
    this.buildForm();
  }

  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [0],
      modulo_codigo: [0],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(25)]],
      descripcion: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true]
    });
  }

  ngOnInit() {
    this.selectedOperacion = {
      codigo: 0,
      nombre: '',
      descripcion: '',
      activado: true,
      fecha_creacion: new Date()
    };
    this.obtenerDatosOperacion();
  }


  showNew() {
    this.formulario.reset();
    this.formulario.get('activado').setValue(true);
  }

  showForEdit(operacion:operacion) {
    this.formulario.get('codigo').setValue(operacion.codigo);
    this.formulario.get('nombre').setValue(operacion.nombre);
    this.formulario.get('descripcion').setValue(operacion.descripcion);
    this.formulario.get('activado').setValue(operacion.activado);
  }

  obtenerDatosOperacion() {
    let self = this; 
    this.client.query({
      query: gql`
      query {
        operacion{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                descripcion
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'no-cache',
    },
    function(respuesta) {
      self.operacionList = respuesta.data.operacion.obtenerTodos.respuesta.registros;
    });
  }

  insertar() {
    this.selectedOperacion.nombre = this.formulario.controls["nombre"].value;
    this.selectedOperacion.descripcion = this.formulario.controls["descripcion"].value;
    this.selectedOperacion.activado = this.formulario.controls["activado"].value;
    this.postOperacion(this.selectedOperacion);
  }

  postOperacion(operacion: operacion) {
    let self = this;
    var bodyx = operacion;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: operacionInputType)
      {
        operacion
        {
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              descripcion
              activado
              fecha_creacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    }, 
    function (respuesta) {
      if (respuesta.data.operacion.agregar.respuesta != undefined)
      {
        setTimeout(() => self.obtenerDatosOperacion(), 1000);
      }
    });
  }

  obtenerDatosSegunFiltro(filtro_nombre:string) {
    let self = this;
    if (filtro_nombre != undefined){
      var bodyx = {
        nombre:filtro_nombre
      };
    }else{
      filtro_nombre ='';
      var bodyx = {
        nombre:filtro_nombre
      };
    }
    this.client.mutate({
      mutation: gql`
      query ($entidad:operacionInputType){
        operacion{
          obtenerSegunFiltro(filtro:{
            exacto:$entidad
          })
          {
            respuesta
            {
              registros
              {
                codigo
                nombre
                descripcion
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        self.operacionList = respuesta.data.operacion.obtenerSegunFiltro.respuesta.registros;
      });
  }

  actualizar()
  {
      this.selectedOperacion.codigo = this.formulario.controls["codigo"].value;
      this.selectedOperacion.nombre = this.formulario.controls["nombre"].value;
      this.selectedOperacion.descripcion = this.formulario.controls["descripcion"].value;
      this.selectedOperacion.activado = this.formulario.controls["activado"].value;
      this.refrescar(this.selectedOperacion);
  }

  refrescar(operacion: operacion) {
    let self = this;
    var bodyx = operacion;
    delete operacion["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: operacionInputType) {
        operacion {
          modificar(entidad: $entidad) {
            mensajes{
              codigo
              contexto
              texto
              tipo
            }
            respuesta{
              nombre
              descripcion
              activado            
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.operacion.modificar.respuesta == null) {
          if (respuesta.data.operacion.modificar.mensajes.length > 0) {
            alert(respuesta.data.operacion.modificar.mensajes[0].texto);
          }
        }
        setTimeout(() => self.obtenerDatosOperacion(), 1000);
      });
  }

  cambiaEstado(operacion:operacion)
  {
    if (operacion.activado)
    {
      operacion.activado = false; 
    }
    else
    {
      operacion.activado = true;
    }
    this.refrescar(operacion);
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(operacion:operacion) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(operacion);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}